import React from "react";
import classes from "./SingleElement.module.css";
import { NavLink } from "react-router-dom";

const SingleElement = (props) => {
	// useEffect(() => {
	// 	if (props.target) window.location.replace(props.to);
	// }, []);
	const onClickHandler = () => {
		if (props.target) window.location.assign(props.to);
	};

	return (
		<div className={[classes.SingleElement, props.className].join(" ")}>
			<a target={props.target} href={props.to}>
				<img src={props.img} alt={props.alt} />
				<h4>{props.title}</h4>
			</a>
		</div>
	);
};

export default SingleElement;
